module.exports = __webpack_public_path__ + "ic-legal-paper.svg?b6f4fd85a5a870afc689642e428bad21";